import {z} from 'zod'
import {EnvironmentName} from '../environment/index.js'

export const WebConfiguration = z.object({
  environmentName: EnvironmentName,
  commitSha: z.string().default('unknown'),
  sentry: z.object({
    dsn: z.string(),
  }),
  auth0: z.object({
    domain: z.string().default('-'),
    clientId: z.string().default('-'),
  }),
  restApi: z.object({
    url: z.string(),
  }),
})
export type WebConfiguration = z.infer<typeof WebConfiguration>
